import api from '@/api';
import {
  NumberInutilizationRequest,
  NumberInutilizationResponse,
} from './numberInutilization.types';
import { API_BASE_URL } from '..';

const CONTROLLER = `${API_BASE_URL}/number-inutilization`;

export default {
  async list(params?: NumberInutilizationRequest) {
    const response = (await api.get(CONTROLLER, params)) as unknown;
    return response as NumberInutilizationResponse;
  },
};
